import {
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useContext } from 'react';
import AgentBuyerSignaturePendingImage from 'assets/images/AgentBuyerSignaturePendingImage.png';
import { poppins300 } from 'theme/common.style';
import CustomStepperAgent from '../CustomStepperAgent';
import { datacontext } from 'modules/AppLayout/AppLayout';

const Step5VendorSignaturePendingAgent = (props) => {
  const { bannerDetails } = props;

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const getPrimaryUserFullName = (ownerDetails) => {
    const names = ownerDetails?.propertyOwnerDetails
      ?.filter((item) => item?.user?.vendorEsignStatus !== 'Completed')
      .map((item) => `${item?.user?.userName} ${item?.user?.userSurName}`)
      .join(', ');

    return names || 'Not Found';
  };

  const ownerFullName = getPrimaryUserFullName(bannerDetails);

  const vendorName = ownerFullName;

  // const ownerFullName = getPrimaryUserFullName(
  //   bannerDetails?.propertyOwnerDetails
  // );

  // const vendorName = ownerFullName;
  const { setShowMessage, setMessagedata } = useContext(datacontext);

  let binderId = bannerDetails?.prepareContractForVendorBinderId;

  const OpenBinderChat = (currentBinder) => {
    if (currentBinder) {
      setShowMessage(true);
      setMessagedata({ binderId: currentBinder });
    }
  };
  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: '#A444AD',
          width: '100%',
          borderRadius: '20px',
          padding: matchessm ? '0 0 20px 0' : '10px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
        }}
      >
        <Grid container xs={12} md={12}>
          <Grid item container xs={12} md={9}>
            <Grid item xs={12}>
              <Stack
                direction={'column'}
                padding={matchessm ? '20px 20px 0 25px' : '30px 0 0 33px'}
              >
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '14px',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: 300,
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  {bannerDetails?.propertyAddress}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                    mt: 1,
                  }}
                >
                  {vendorName} - Vendor Signature Pending
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  The Vendor has not yet signed the Contract of Sale. Follow up
                  the{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {vendorName}
                  </Typography>
                  &nbsp;now.
                </Typography>
              </Stack>
            </Grid>
            <Grid item container xs={12} alignItems={'center'}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  display: 'flex',
                  justifyContent: matchessm ? 'space-between' : 'start',
                  gap: matchessm ? 1 : 2,
                  padding: matchessm ? '0 30px 0 30px' : '0 0 0 33px',
                }}
              >
                <Button
                  onClick={() => {
                    OpenBinderChat(binderId);
                  }}
                  sx={{
                    width: matchessm ? 'auto' : '165px',
                    gap: matchessm ? '5px' : '10px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: '#FFFFFF',
                    color: '#A444AD',
                    '&:hover': {
                      bgcolor: '#FFFFFF',
                      color: '#A444AD',
                    },
                  }}
                >
                  Follow Up
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} alignItems={'center'}>
                <CustomStepperAgent stepValue={2} requestEsign={true} />
              </Grid>
            </Grid>
          </Grid>
          {!matchesmd && (
            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
              mt={2}
            >
              <img
                src={AgentBuyerSignaturePendingImage}
                alt="AgentBuyerSignaturePendingImage"
                style={{
                  objectFit: 'contain',
                  height: '257px',
                  width: '264px',
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    </>
  );
};

export default Step5VendorSignaturePendingAgent;
